export default __webpack_public_path__ + "static/hiiotcase1-93b915236cfc3986a97319bdedc05029.png";